import { render, staticRenderFns } from "./home.vue?vue&type=template&id=0c1132c8&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=0c1132c8&prod&lang=scss&"
import style1 from "./home.vue?vue&type=style&index=1&id=0c1132c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1132c8",
  null
  
)

export default component.exports